var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStunningVisual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.456,
    height: 268,
    viewBox: "0 0 235.456 268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9034910_logo_apple_ar_icon",
    "data-name": "9034910_logo_apple_ar_icon",
    transform: "translate(-55.768 -25.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157073",
    "data-name": "Path 157073",
    d: "M201.14,50.25,232.427,32l31.287,18.25",
    transform: "translate(-58.927)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 46,
    transform: "translate(174 31.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157074",
    "data-name": "Path 157074",
    d: "M263.715,448l-31.287,18.25L201.14,448",
    transform: "translate(-58.927 -178.75)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y1: 46,
    transform: "translate(174 241.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157075",
    "data-name": "Path 157075",
    d: "M64,166.681V130.461L94.312,112.49",
    transform: "translate(0 -34.586)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 38.376,
    y2: 22.813,
    transform: "translate(64 95.875)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157076",
    "data-name": "Path 157076",
    d: "M425.162,304.49v36.221L394.85,358.681",
    transform: "translate(-142.162 -117.086)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 38.376,
    y1: 22.813,
    transform: "translate(244.624 200.813)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157077",
    "data-name": "Path 157077",
    d: "M94.312,358.961,64,340.711V304.49",
    transform: "translate(0 -117.086)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 22.813,
    x2: 38.006,
    transform: "translate(64 200.813)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157078",
    "data-name": "Path 157078",
    d: "M394.85,112.49l30.312,17.971v36.221",
    transform: "translate(-142.162 -34.586)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 38.376,
    y2: 22.813,
    transform: "translate(244.624 95.875)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157079",
    "data-name": "Path 157079",
    d: "M256,278.75v-36.5L287.287,224",
    transform: "translate(-82.5 -82.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 31.287,
    y1: 18.25,
    transform: "translate(142.213 141.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStunningVisual);
export default __webpack_public_path__ + "static/media/stunning-visual.7b3560f014a9f4b7f70e09a27a59aa1b.svg";
export { ForwardRef as ReactComponent };